export default __webpack_public_path__ + "static/hiring-partner-banner-1a7ecdf350fd657e78881d6217becc3c.jpeg";